export default __webpack_public_path__ + "static/media/jest.9af4e60c.svg";